import { Component, Input, isDevMode, OnInit } from '@angular/core';
import { HeaderFieldComponent, CellFieldComponent, AttachmentLookupComponent } from '../../common/index';
import { AdminService, MetadataService, AuthService, ApiService, SessionService, ModalService, ConditionService, CalendarService, TranslatorService, FieldService } from '../../../services';
import { ModalComponent } from '../../modal/modal.component';
import { Condition } from '../../../models';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UscModalComponent } from '../usc-modal/usc-modal.component';
import { BuiltinVar } from '@angular/compiler';

@Component({
    selector: 'sn-usc-p2w-associate-detail-results',
    templateUrl: './usc-p2w-associate-detail-results.component.html',
    styleUrls: ['./usc-p2w-associate-detail-results.component.css']
})
export class UscP2wAssociateDetailResultsComponent implements OnInit {
    @Input() view: string;
    @Input() scope_type: string;
    @Input() scope_value: string;

    public detail_items: Array<any> = [];
    public filtered_detail_items: Array<any> = [];
    public cur_month_detailed_items: Array<any>;
    public prev_month_detailed_items: Array<any> = [];
    public available_months:Array<any> = [];
    public columnFields: Array<any> = [];
    public visibleColumnFields: Array<any> = [];
    private viewConditions: Array<any> = [];
    public detail_items_loaded: boolean = false;
    public current_filtered_values: any = {}
    public is_group_label_enabled: boolean = false;
    public column_groups: any = [];
    public gross_adds_btn_class: string;
    public accessory_btn_class: string;
    public action_plan_fields: any[];
    public current_month: string;
    public max_num_months: number = 12;
    public isPreviousMonthEnabled: boolean = true;
    portalReadySub: Subscription;
    // search
    public searchText: string;
    // paging 
    public curPage: number = 1;
    public pageSize: number = 15;
    public pageCount: number = 0;
    public itemCount: number = 0;
    public orderBy: string = 'cs_case_number';
    public asc: boolean;
    protected conditionResults: Array<Condition> = [];
    public header_style: any = { 'font-size': '12px', 'font-weight': 'bold', 'color': 'white', 'text-align': 'center' }

    constructor(
        public ngbModal: NgbModal,
        public modalService: ModalService,
        public adminService: AdminService,
        public metadataService: MetadataService,
        public authService: AuthService,
        public apiService: ApiService,
        public sessionService: SessionService,
        public conditionService: ConditionService,
        public uscStoreService: UscStoreService,
        public calendarService: CalendarService,
        public translatorService: TranslatorService,
        public fieldService: FieldService,
    ) {
    }

    ngOnInit() {
        // order of operations
        // 1. load metadata to get column_fields and view_conditions
        // 2. load action plans 
        // 3. evaluate view_conditions for each action plan
        // 4. determine viewable columns by column_field's visible/sn_column_visible
        // 5. generate filter data for each filter columns
        this.loadTableViewMetaData();

        this.isPreviousMonthEnabled = !this.uscStoreService.isUSCellAgent();
        this.current_month = this.uscStoreService.getThisMonthActionPlanSubject();
        this.available_months = [ this.uscStoreService.getThisMonthActionPlanSubject() ];
        this.portalReadySub = this.uscStoreService.portalReady.subscribe(ready => {
            if (ready) this.reloadItems();
        });

        this.uscStoreService.reloadP2WAchievements.subscribe(bReload => {
            if (bReload) {
                this.reloadItems(true);
            }
        });
    }

    loadTableViewMetaData() {
        this.detail_items_loaded = false;
        this.visibleColumnFields = [];
        this.columnFields = [];
        this.metadataService.getTableViewMetaData(this.view, {}, true).subscribe(result => {
            this.columnFields = result.meta_data.column_fields;
            this.viewConditions = result.meta_data.view_conditions;
            // load view items here after meta data is downloaded
            this.reloadItems();
        });
    }

    // gather all search params in json format to be used as request string parameter
    getSearchParams(executeScriptType: string = null) {
        var params: any = {}
        params.p = this.curPage;
        params.ps = this.pageSize;
        params.ob = this.orderBy;
        if (executeScriptType) params.est = executeScriptType;
        params.obd = this.asc ? "asc" : "desc";
        return params;
    }

    getExecuteScriptType(bSearchData: boolean = true, bTotalCount: boolean = true) {
        if (bSearchData && bTotalCount) return "ST_All";
        if (bSearchData) return "ST_Search";
        if (bTotalCount) return "ST_TotalCount";
    }

    updateDetailedResults(month:string) {
        this.current_month = month;
        this.reloadItems();
    }

    reloadItems(bResetDetailedItems = false) {
        // reset state variable before reloading action plans
        if (bResetDetailedItems) this.cur_month_detailed_items = null;
        this.current_filtered_values = {};
        this.detail_items = [];
        this.column_groups = [];
        let dlg = this.showCustomPromptDlg({ }, { msg: "Loading Detailed Results" });
        if (this.current_month == this.uscStoreService.getThisMonthActionPlanSubject()) {
            if (this.cur_month_detailed_items) {
                this.detail_items = this.cur_month_detailed_items;
                dlg.dismiss();
                this.processDetailedItems();
            } else {
                var params = this.getSearchParams(this.getExecuteScriptType(true, false));
                this.uscStoreService.getData(this.view, params).subscribe(
                    result => {
                        this.uscStoreService.setCurrentViewItems(result.items);
                        this.cur_month_detailed_items = result.items;
                        this.detail_items = this.cur_month_detailed_items;
                        dlg.dismiss();
                        this.processDetailedItems();
                    },
                    err => {
                        console.log(err);
                    }
                );
            }
        } else {
            var params = this.getSearchParams(this.getExecuteScriptType(true, false));
            params["SP_MONTH_SUBJECT"] = this.current_month;
            this.uscStoreService.getData(this.view, params).subscribe(
                result => {
                    this.uscStoreService.setCurrentViewItems(result.items);
                    this.cur_month_detailed_items = result.items;
                    this.detail_items = this.cur_month_detailed_items;
                    dlg.dismiss();
                    this.processDetailedItems();
                },
                err => {
                    console.log(err);
                }
            );
        }
    }

    processDetailedItems() {
        // sort items by close date descending order
        this.detail_items.sort(function (a, b) {
            var a_date = new Date(a.dl_close_date);
            var b_date = new Date(b.dl_close_date);
            return (a_date < b_date) ? 1 : -1;
        })

        this.filtered_detail_items = this.detail_items;
        this.detail_items_loaded = true;

        this.detail_items.forEach(ap => {
            if (this.viewConditions) {
                var conditions = JSON.parse(JSON.stringify(this.viewConditions));
                ap.viewConditions = this.conditionService.evaluateItemValues(conditions, null, ap);
            }
        });

        // extract all visible columns
        this.visibleColumnFields = [];
        this.columnFields.forEach(cf => {
            if (cf.visible) {
                var bVisible = true;
                if (cf.sn_column_visible) {
                    var condResult = this.conditionService.getCondition(this.detail_items[0].viewConditions, cf.sn_column_visible);
                    bVisible = condResult ? condResult.result : true;
                }
                if (bVisible) this.visibleColumnFields.push(cf);
            }
        })
        this.itemCount = this.visibleColumnFields.length;
        this.pageCount = 1;

        // from visible columns, pre-construct grouping <td>
        if (this.visibleColumnFields.find(f => f.group_label != null && f.group_label.length > 0) != null) this.is_group_label_enabled = true;
        if (this.is_group_label_enabled) {
            this.column_groups = [];
            for (var i = 0; i < this.visibleColumnFields.length; i++) {
                var curr_field = this.visibleColumnFields[i];
                var curr_group_label = curr_field.group_label ? curr_field.group_label : '';
                var g = this.column_groups.find(cg => cg.label == curr_group_label);
                if (g == null) {
                    g = { label: curr_group_label, colspan: 1, class: curr_field.cell_class }
                    this.column_groups.push(g);
                } else {
                    g.colspan++;
                }
            }
        }

        this.generateFilterData();
    }

    prevPage() {
        if (this.curPage > 1) {
            this.curPage--;
            this.reloadItems();
        }
    }

    nextPage() {
        if (this.curPage < this.pageCount) {
            this.curPage++;
            this.reloadItems();
        }
    }

    onColumnSort(event) {
        // default to asc = true if switching to a different column, else flip the currect sort state
        this.asc = event.field.key != this.orderBy ? true : !this.asc;
        this.orderBy = event.field.key;
        this.setActiveSortColumn(event.field.key);
        this.reloadItems();
    }

    setActiveSortColumn(column_key: string) {
        for (var i = 0; i < this.columnFields.length; i++) {
            var field = this.columnFields[i];
            field.sort_active = (field.key == column_key);
        }
    }

    getFieldValueStyle(detail_item, field) {
        var fvc = {};
        if (detail_item && field) {
            var field_value = detail_item[field.key];
            switch (field.key) {
                default:
                    break;
            }
        }

        var item_index = this.detail_items.indexOf(detail_item);
        fvc["background-color"] = item_index % 2 == 0 ? "#F6F6F6" : "white";
        return fvc;
    }

    getMonthDisplayValue(month) { return this.uscStoreService.convertPlanMonth(month); }

    getFieldValue(detail_item, field): any {
        if (detail_item && field) {
            var isImpression = detail_item["type"] && detail_item["type"].indexOf("Impression") >= 0
            var field_value = detail_item[field.key];
            switch (field.key) {
                case 'spiff_desc': return (isImpression) ? '-' : field_value;
                case 'dl_close_date': field_value =  field_value.substr(0, 10); break;
                // case 'postpaid_basic': 
                // case 'postpaid_everyday': 
                // case 'postpaid_even_better': 
                // case 'postpaid': 
                // case 'connected_devices': 
                // case 'prepaid': 
                // case 'hsi': 
                // case 'bir': 
                // case 'upgrades_basic': 
                // case 'upgrades_everyday': 
                // case 'upgrades_even_better': 
                // case 'upgrades': 
                // case 'dp_basic': 
                // case 'dp_std': 
                // case 'dp_adv': 
                // case 'dp_acs': 
                // case 'accessories_revenue': 
                // case 'high_msrp_accessories': 
                case 'spiff':
                    if (isImpression) field_value = '-'; 
                    // fall through intended
                default:
                    if (field.key.indexOf('revenue') >= 0) field_value = this.translatorService.toCurrency(field_value, 2);
                    break;
            }

            return field_value != null ? field_value : 0;
        }
        return null;
    }

    onBtnClick(btn, item_sale, field) {
        switch (btn.event) {
            case "sn_edit": 
            case "sn_quick_sale": 
                this.updateQuickSale(btn, item_sale, field); break;
            case "sn_delete": 
                this.deleteQuicksale(btn, item_sale, field); break;
        }
    }

    deleteQuicksale(btn, item_sale, field) {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
        modalRef.componentInstance.msg_config =  { msg: "Removing Quick Sale" };
        this.apiService.processActionOnViewItem(this.view, item_sale.view_ID, this.uscStoreService.action_usc_quick_sale_deletion, null).subscribe(
            result => {
                modalRef.dismiss();
                this.reloadItems(true);
            }
        )
    }

    updateQuickSale(btn, item_sale, field) {
        var isChargeBack = item_sale.sub_type == 'Charge Back';
        let quick_sale = { 
            dl_ID: item_sale.type && item_sale.type.indexOf('Impression') >= 0 ? 0 : item_sale.dl_ID,           // only return deal ID for non-impression deals for quick sale/bi adjustment create/edit
            dl_type: item_sale.type, 
            dl_sub_type: item_sale.sub_type, 
            dl_close_date: item_sale.dl_close_date ? item_sale.dl_close_date.substr(0, 10) : '', 
            cfd_oid: item_sale.order_id,
            dl_postpaid_basic: isChargeBack ? item_sale.cb_postpaid_basic : item_sale.postpaid_basic,
            dl_postpaid_everyday: isChargeBack ? item_sale.cb_postpaid_everyday : item_sale.postpaid_everyday,
            dl_postpaid_even_better: isChargeBack ? item_sale.cb_postpaid_even_better : item_sale.postpaid_even_better,
            dl_estimated_units: isChargeBack ? item_sale.cb_postpaid : item_sale.postpaid,
            dl_connected_device: isChargeBack ? item_sale.cb_connected_devices : item_sale.connected_devices,
            dl_prepaid: isChargeBack ? item_sale.cb_prepaid : item_sale.prepaid,
            dl_hsi: isChargeBack ? item_sale.cb_hsi : item_sale.hsi,
            dl_bir: isChargeBack ? item_sale.cb_bir : item_sale.bir,
            dl_upgrades_basic: isChargeBack ? item_sale.cb_upgrades_basic : item_sale.upgrades_basic,
            dl_upgrades_everyday: isChargeBack ? item_sale.cb_upgrades_everyday : item_sale.upgrades_everyday,
            dl_upgrades_even_better: isChargeBack ? item_sale.cb_upgrades_even_better : item_sale.upgrades_even_better,
            dl_estimated_value: isChargeBack ? item_sale.cb_upgrades : item_sale.upgrades,
            dl_estimated_value3: isChargeBack ? item_sale.cb_accessories_revenue : item_sale.accessories_revenue,
            dl_estimated_units3: isChargeBack ? item_sale.cb_high_msrp_accessories : item_sale.high_msrp_accessories,
            cfd_dti: isChargeBack ? item_sale.cb_device_trade_ins : item_sale.device_trade_ins,
            dl_estimated_value4: isChargeBack ? item_sale.cb_every_day_plans : item_sale.every_day_plans,
            dl_estimated_units5: isChargeBack ? item_sale.cb_even_better_plans : item_sale.even_better_plans,
            cfd_dpb: isChargeBack ? item_sale.cb_dp_basic : item_sale.dp_basic,
            cfd_dps: isChargeBack ? item_sale.cb_dp_std : item_sale.dp_std,
            cfd_dpa: isChargeBack ? item_sale.cb_dp_adv : item_sale.dp_adv,
            cfd_dpacs: isChargeBack ? item_sale.cb_dp_acs : item_sale.dp_acs,
            cfd_spiff: isChargeBack ? item_sale.cb_spiff : item_sale.spiff,
            cfd_spiff_desc: isChargeBack ? item_sale.cb_spiff_desc : item_sale.spiff_desc,
            co_firstname: item_sale.firstname,
            co_lastname: item_sale.lastname,
            co_work_phone1: item_sale.work_phone1,
            cfd_an: item_sale.account_number,
        };

        const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.view = this.uscStoreService.form_quick_sale;   
        modalRef.componentInstance.onCustomValidateEvent = this.onQuickSaleValidation; 
        modalRef.componentInstance.onSubmitOverrideEvent = this.onQuickSaleSubmit;
        modalRef.componentInstance.data = quick_sale;
        modalRef.result.then((result) => {
            console.log(result);
            let item: any = {};

        }, (reason) => {
            console.log(reason);
        });
    }

    onQuickSaleValidation(services, event, btn_event, newFormFields) {
        var validation = { status: true, error_msg: '' }
        var bIsChargeBack = false, bValid = true;
        newFormFields.forEach(f => { if (f["key"] == "dl_sub_type") bIsChargeBack = f["value"] == "Charge Back"; });
        newFormFields.forEach(f => {
            //if (bValid && f["value"] != null && f["value"] != '') {
            if (bValid) {
                switch (f["key"]) {
                    case "dl_postpaid_basic":
                    case "dl_postpaid_everyday":
                    case "dl_postpaid_even_better":
                    case "dl_estimated_units":
                    case "dl_connected_device": 
                    case "dl_prepaid": 
                    case "dl_hsi": 
                    case "dl_bir": 
                    case "dl_upgrades_basic":
                    case "dl_upgrades_everyday":
                    case "dl_upgrades_even_better":
                    case "dl_estimated_value": 
                    case "dl_estimated_value3": 
                    case "dl_estimated_units3": 
                    case "cfd_dti": 
                    case "dl_estimated_value4": 
                    case "dl_estimated_units5": 
                    case "cfd_dpb": 
                    case "cfd_dps": 
                    case "cfd_dpa": 
                    case "cfd_dpacs": 
                    case "cfd_spiff": 
                        if (f["value"] == null || f["value"] == '') f["value"] = 0;
                        bValid = bIsChargeBack ? parseInt(f["value"]) <= 0 : parseInt(f["value"]) >= 0;
                        break;
                }
            }
        })
        if (!bValid) {
            if (bIsChargeBack) validation = { status: false, error_msg: 'All Charge Back sales figures must be less or equal to 0.' }
            if (!bIsChargeBack) validation = { status: false, error_msg: 'All Quick Sale figures must be greater or equal to 0.' }
        }
        return validation;
    }

    onQuickSaleSubmit(services, event, btn_event, newFormFields) {
        var params = { event: btn_event };
        var order_ID = 0;
        var dl_ID = 0;
        newFormFields.forEach(f => { 
            if (f["key"] == "cfd_oid") order_ID = f["value"]; 
            if (f["key"] == "dl_ID") dl_ID = f["value"]; 
        });
        var data = { "Order ID": order_ID, "dl_ID": dl_ID };

        var showCustomPromptDlg = function(services, msg_config):NgbModalRef {
            const modalRef = services.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
            modalRef.componentInstance.dlgType = services.uscStoreService.dialog_type_custom_msg;
            modalRef.componentInstance.msg_config = msg_config;
            return modalRef;
        }    

        var reloadP2WAchievements = function() {
            services.uscStoreService.setActionPlan(null);
            services.uscStoreService.setTodaysGoal(null);
            services.uscStoreService.triggerReloadP2WAchievements();
        }

        let dlg = showCustomPromptDlg(services, { msg: "Validating..." });
        services.uscStoreService.processActionOnViewItem(services.uscStoreService.form_quick_sale, 0, services.uscStoreService.action_quick_sale_order_id_query, data).subscribe(
            result => {
                dlg.dismiss();
                if (result.data.sale_type && result.data.sales_figures) {
                    const modalRef = services.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
                    modalRef.componentInstance.parentView = this.view;
                    modalRef.componentInstance.dlgType = services.uscStoreService.dialog_type_quick_sale_details;
                    modalRef.componentInstance.data = result.data;
                    modalRef.componentInstance.quick_sale = newFormFields;
                    modalRef.result.then((r) => {
                        if (r.response) {
                            dlg = showCustomPromptDlg(services, { msg: "Updating Sales..." });
                            this.uscStoreService.saveOutcome(services.uscStoreService.form_quick_sale, 0, newFormFields, params).subscribe(
                                result => { 
                                    dlg.dismiss();
                                    reloadP2WAchievements();
                                    console.log('quick sale saved'); 
                                    if (services.activeModal) services.activeModal.close({ event: btn_event, data: null });
                                },
                            );
                        } 
                    }, (reason) => {
                        console.log("quick sale cancelled");
                    });
                } else {
                    this.uscStoreService.saveOutcome(services.uscStoreService.form_quick_sale, 0, newFormFields, params).subscribe(
                        result => { 
                            reloadP2WAchievements();
                            if (services.activeModal) services.activeModal.close({ event: btn_event, data: null });
                            console.log('quick sale saved'); 
                        }
                    );
                }
            }, error => {
                //this.sessionService.log("unknown error");
            }
        );       
    }

    showCustomPromptDlg(item, msg_config): NgbModalRef {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.view;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
        modalRef.componentInstance.msg_config = msg_config;
        return modalRef;
    }

    isValueVisible(action_plan, field) {
        return true;
    }

    isBtnVisible(btn, action_plan, field) {
        if (action_plan && action_plan.viewConditions) {
            var condResult = this.conditionService.getCondition(action_plan.viewConditions, btn.sn_visible);
            return condResult ? condResult.result : true;
        }
        return true;
    }

    isColumnVisible(column) {
        switch (column.key) {
            default:
                return column.visible;
        }
    }

    isImageIcon(btn) { return (btn.button_type == "IMG"); }
    isFontAwesomeIcon(btn) { return (btn.button_type == "FA"); }

    // #region Data Filters
    generateFilterData() {
        this.columnFields.forEach(f => {
            if (f.enable_filtering) f.filter_data = this.getDataFilter(f);
        })
    }

    getDataFilter(field) {
        var filter_list = [{ label: 'All', value: '' }];
        if (this.detail_items_loaded && field.enable_filtering) {
            if (field.filter_data_source == 'data') {
                this.filtered_detail_items.forEach(ap => {
                    var field_value = this.getFieldValue(ap, field);
                    var filter = filter_list.find(f => f.value == field_value);
                    if (filter == null) {
                        filter_list.push({ label: field_value, value: field_value });
                    }
                })
            }
            filter_list.sort(function (a, b) {
                if (a.value < b.value) return -1;
            })
        }
        return filter_list;
    }

    showFilteredValue(field): boolean {
        return (field && field.current_filtered_value);
    }

    getFilteredValue(field) {
        return field.current_filtered_value;
    }

    filter(field, f) {
        field.current_filtered_value = (f.value == 'All' || f.value == '') ? null : f.value;
        this.updateFilteredDetailItems();
    }

    updateFilteredDetailItems() {
        this.filtered_detail_items = [];
        this.detail_items.forEach(ap => {
            var bInclude = true;
            this.columnFields.forEach(f => {
                if (f.enable_filtering && f.current_filtered_value) {
                    bInclude = bInclude && ((ap[f.key] == f.current_filtered_value) ? true : false);
                }
            })
            if (bInclude) this.filtered_detail_items.push(ap);
        })
        this.generateFilterData();
    }
    // #endregion


    ngOnDestroy() {
        if (this.portalReadySub) this.portalReadySub.unsubscribe();
    }

}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-p2w-associate-detail-results/usc-p2w-associate-detail-results.component.ts